import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    supportedMethods: null,
    loading: false,
    error: null,
};

const doorKeySlice = createSlice({
    name: 'doorKey',
    initialState,
    reducers: {
        doorKeyRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        doorKeySuccess: (state, action) => {
            state.loading = false;
            state.error = null;
        },
        doorKeySupportedMethods: (state, action) =>{
            state.supportedMethods = action.payload;
        },
        doorKeyFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const { doorKeyRequest, doorKeySuccess, doorKeySupportedMethods, doorKeyFailure } = doorKeySlice.actions;

export default doorKeySlice.reducer;